import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { ListLikeToneRequest } from './listliketonerequest';

export class ListLikeToneAPI extends SixdeeCRBTAPI<ListLikeToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/listing-liked-tone
        return "listing-liked-tone"+"?"+"aPartyMsisdn="+ this.getRequest().getListLikeToneRequest().getAPartyMsisdn();
    }

    /* getHttpHeaders():string
    {
        return {
            "aPartyMsisdn" : this.getRequest().getListLikeToneRequest().getAPartyMsisdn(),
            "clientTxnId" : "15052020",
            "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            "appId" : "com.sixdee.callertunes_etisalat",
            "appVersion" : "1.0.6",
            "channelId" : "9",
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
             "accessToken" : this.getContext().getUserContext().getAccessToken()
        } as any;
    } */

    getRequestData()
    {
        return ""; /* "aPartyMsisdn="+ this.getRequest().getListLikeToneRequest().getAPartyMsisdn()+"&"+
               "clientTxnId=15052020"; */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/listlikedtone/listliketoneapi.tsx